import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map, Observable } from 'rxjs';
import { selectUserRoles } from 'src/app/auth/state/selectors/auth.selectors';
import { User } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class HasNativaRoleGuard  {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.store.select(selectUserRoles).pipe(
        first((userRoles: User.UserRole[]) => !!userRoles),
        map((userRoles: User.UserRole[]) => {
          const hasNativaRole = userRoles.some((role) =>
            [User.UserRole.NATIVA].includes(role)
          );
          if (hasNativaRole) {
            return true;
          }
          this.router.navigate(['home']);
          return false;
        })
      );
  }
}
